<template>
  <div id="curve-chart"  :class="random">
    <span>Slope: {{slope > 0 ? '+' : ''}}{{slope}} avg. cases per day</span>
    <div id="chartWrapper">
      <div id="curveChart"></div>
    </div>
  </div>
</template>

<script>
import * as d3 from "d3"
import _ from "lodash"
import moment from "moment"

// let green = "#329c00"
// let red = "#e20000"
// let yellow = "#f9df00"
// let gray = "#999999"

let sum = (a, b) => a + b
let timeParse = d3.timeParse("%Y-%m-%d")
let casesColor = "hsl(11, 94%, 65%)"
let casesColorHover = "hsl(2, 74%, 51%)"
let lineColor = "hsl(0, 100%, 54%)"
let dotColorHover = "hsl(203deg 100% 50%)"
let format = d3.format(",")
let formatNoDecimal = d3.format(",.0f")

export default {
  props: {
    cases: null,
    start: null,
    end: null,
    reopenings: null,
    keyReopening: null,
  },
  data: () => ({
    random: "id-" + Math.round(Math.random()*1000000000),
    slope: 0,
    data: null,
  }),
  watch: {
    cases() {
      this.updateStateCasesChart()
    },
  },
  mounted() {
  },
  beforeDestroy() {
  },
  created() {
    setTimeout(() => 
      this.updateStateCasesChart()
    )
  },
  methods: {
    updateStateCasesChart: function() {
      // Filter and transform data

      let groupedByDate = _.groupBy(
        this.cases,
        "date"
      )

      let casesDates = this.cases
        // .filter(d => d.state == stateName)
        .map(d => d.date)
        .sort()
      let stopDate = moment(casesDates[casesDates.length - 1])
      // if (this.end) {
      //   stopDate = moment(this.end)
      // }
      var dateArray = []
      let mainStart = "2020-02-26"
      // if (this.start) {
      //   mainStart = this.start
      // }
      var currentDate = moment(mainStart)
      while (currentDate.isSameOrBefore(stopDate)) {
        dateArray.push(currentDate.format("YYYY-MM-DD"))
        currentDate = currentDate.add(1, "days")
      }

      let casesByDate = _.map(dateArray, date => {
        let arr = groupedByDate[date] || []
        return {
          date: date,
          cases: arr.map(d => +d.cases).reduce(sum, 0),
          deaths: arr.map(d => +d.cases).reduce(sum, 0)
        }
      })
      casesByDate = _.orderBy(casesByDate, ["date"], ["asc"]).filter(
        d => d.date >= mainStart
      )
      let pastCases = 0
      let pastDeaths = 0
      let pastNCases = []
      let dayAverage = 7
      let minCases = 0
      let firstIxOverMin = -1

      casesByDate.forEach((d, ix) => {
        if (firstIxOverMin === -1 && +d.cases >= minCases) {
          firstIxOverMin = ix
        }
        d.newCases = d.cases - pastCases
        d.newDeaths = d.deaths - pastDeaths

        pastNCases.push(d.newCases)
        pastNCases = pastNCases.splice(
          Math.max(0, pastNCases.length - dayAverage),
          dayAverage
        )
        d.average = pastNCases.reduce(sum, 0) / pastNCases.length

        pastCases = d.cases
        pastDeaths = d.deaths
      })
      casesByDate.splice(0, firstIxOverMin)

      // casesByDate.shift()

      if (this.start) {
        casesByDate = casesByDate.filter(d => moment(this.start).isSameOrBefore(d.date))
      }
      if (this.end) {
        casesByDate = casesByDate.filter(d => moment(this.end).isSameOrAfter(d.date))
      }
      console.log(casesByDate)

      let data = casesByDate.map(d => ({
        date: timeParse(d.date),
        newCases: d.newCases,
        average: d.average
      }))

      this.data = data

      var margin = { top: 20, right: 20, bottom: 30, left: 30 },
        width = 400 - margin.left - margin.right,
        height = 200 - margin.top - margin.bottom

      // Set the ranges
      var x = d3
        .scaleBand()
        .range([0, width])
        .paddingInner(0.1)
        .paddingOuter(1)
      var y = d3.scaleLinear().range([height, 0])

      // Scale the range of the data in the domains
      x.domain(data.map(d => d.date))
      y.domain([
        0,
        d3.max(data, function(d) {
          return d.newCases
        })
      ])

      // Create svg
      d3.select(`.${this.random} #curveChart svg`).remove()
      var svg = d3
        .select(`.${this.random} #curveChart`)
        .append("svg")
        .attr("preserveAspectRatio", "xMinYMin meet")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .style("width", "100%")
        .attr(
          "viewBox",
          `0 0 ${width + margin.left + margin.right} ${height +
            margin.top +
            margin.bottom}`
        )
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")")

      // Define tooltip
      d3.select(`.${this.random} #curveChart .tooltip-label`)
      var tooltip = d3
        .select(`.${this.random} #curveChart`)
        .append("div")
        .attr("class", "tooltip-label")
        .style("opacity", 0)

      let that = this
      let showTooltip = function(html) {
        let chartRect = d3
          .select(`.${that.random} #curveChart`)
          .node()
          .getBoundingClientRect()
        tooltip
          .transition()
          .duration(0)
          .style("opacity", 0.93)
        tooltip
          .html(html)
          .style("left", d3.event.clientX - chartRect.x + 5 + "px")
          .style("top", d3.event.clientY - chartRect.y - 28 + "px")
      }

      let hideTooltip = function() {
        tooltip
          .transition()
          .duration(500)
          .style("opacity", 0)
      }

      // Add main action line
      if (this.keyReopening) {
        let date = timeParse(moment(this.keyReopening.dateStart).format("YYYY-MM-DD"))
        svg.append("line")
          .attr("stroke", 'red')
          .attr("stroke-width", 2)
          .attr("x1", x(date))
          .attr("y1", 0)
          .attr("x2", x(date))
          .attr("y2", height)
      }

      // Add the x Axis
      let xAxis = d3
        .axisBottom()
        .scale(x)
        .tickFormat(d3.timeFormat("%b %d"))
        .ticks(d3.timeDay.every(3))
        .tickSizeOuter([100])
      svg
        .append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + height + ")")
        .call(xAxis)
        .selectAll("text")
        .attr("transform", "translate(0,-3)rotate(315)")
        // .attr("transform", "translate(0,-3px)rotate(315)")
        .style("text-anchor", "end")

      // Add the y Axis
      svg.append("g").call(d3.axisLeft(y))

      // Add bar cases
      svg
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("fill", "none")
        // .attr("fill", casesColor)
        .attr("class", "bar")
        .attr("x", function(d) {
          return x(d.date)
        })
        .attr("width", x.bandwidth())
        .attr("y", function(d) {
          return y(d.newCases)
        })
        .attr("height", function(d) {
          return height - y(d.newCases)
        })
        .on("mouseover", function(d) {
          d3.select(this).attr("fill", casesColorHover)
          showTooltip(
            `<b>${d3.timeFormat("%b %d")(d.date)}</b><br>${format(
              d.newCases
            )} cases`
          )
        })
        .on("mouseout", function(d) {
          d3.select(this).attr("fill", casesColor)
          hideTooltip()
        })

      // Create line color (gradient)
      let stops = []
      let stopReopenings = this.reopenings
      if (this.keyReopening) {
        stopReopenings = stopReopenings.filter(d => d.category == this.keyReopening.category)
      }
      if (stopReopenings && stopReopenings.length) {
        stops = stopReopenings.map(d => ({
          date: d.dateStart,
          color: d.color
        }))
        let last = stopReopenings[stopReopenings.length - 1]
        stops.push(({
          date: last.dateEnd,
          color: last.color
        }))
      }
      stops.forEach(d => {
        d.x = x(d.date) / width
      })
      stops = stops.filter(d => !isNaN(d.x))
      let hardStops = []
      for (let i = 1; i < stops.length; i++) {
        hardStops.push({
          x: stops[i].x - 0.000001,
          color: stops[i-1].color,
        })
      }
      stops.push(...hardStops)
      stops = _.orderBy(stops, 'x')
      let gradientId = this.random + "-line-color"
      svg
        .append("defs")
        .append("linearGradient")
          .attr("id", gradientId)
          .attr("gradientUnits", "userSpaceOnUse")
          .attr("x1", 0)
          .attr("x2", width)
        .selectAll("stop")
        .data(stops)
        .join("stop")
          .attr("offset", d => d.x)
          .attr("stop-color", d => d.color)

      console.log("stops")
      console.log(stops)

      // Add line average
      var line = d3
        .line()
        .x(function(d, i) {
          return x(d.date)
        })
        .y(function(d) {
          return y(d.average)
        })
        .curve(d3.curveMonotoneX) // apply smoothing to the line
      let lineG = svg.append("g")
      lineG
        .append("path")
        .datum(data)
        .attr("class", "line")
        .attr("fill", "none")
        // .attr("stroke", lineColor)
        // .attr("stroke", function (d) {
        //   return (Math.random() > 0.5) ? 'red' : 'blue';
        // })
        .attr("stroke", `url(#${gradientId})`)
        .attr("stroke-width", "3")
        .attr("d", line)

      // Add dots on average
      lineG
        .selectAll(".dot")
        .data(data)
        .enter()
        .append("circle")
        .attr("class", "dot")
        .attr("fill", "transparent")
        .attr("cx", function(d, i) {
          return x(d.date)
        })
        .attr("cy", function(d) {
          return y(d.average)
        })
        .attr("r", 6)
        .on("mouseover", function(d) {
          d3.select(this)
            .attr("fill", dotColorHover)
            .raise()
          showTooltip(
            `<b>${d3.timeFormat("%b %d")(d.date)}</b><br>${formatNoDecimal(
              d.average
            )} cases (7-day average)`
          )
        })
        .on("mouseout", function() {
          d3.select(this)
            .attr("fill", "transparent")
            .raise()
          hideTooltip()
        })

      // Add reopening marks
      let reopeningData = this.reopenings.map(d => {
        let date = timeParse(moment(d.dateStart).format("YYYY-MM-DD"))
        let average = this.data.filter(d => d.date >= date).map(d => d.average)[0]
        return {
          nameDisplay: d.category,
          statusDisplay: { "Red": "Closed","Yellow": "Open with restrictions","Green": "Open" } [d.statusColor],
          date: date,
          x: x(date),
          y: y(average)
        }
      })
      reopeningData = reopeningData.filter(d => !isNaN(d.x))
      svg.append("g")
        .selectAll(".reopening")
        .data(reopeningData)
        .enter()
        .append("line")
          .attr("class", "reopening")
          .attr("stroke", 'purple')
          .attr("stroke-width", 9)
          .attr("x1", d => d.x)
          .attr("y1", d => d.y - 10)
          .attr("x2", d => d.x)
          .attr("y2", d => d.y + 10)
          .on("mouseover", function(d) {
            d3.select(this)
              .attr("stroke", dotColorHover)
              .raise()
            showTooltip(
              `<b>${d3.timeFormat("%b %d")(d.date)}</b><br>${d.nameDisplay}: ${d.statusDisplay}`
            )
          })
          .on("mouseout", function() {
            d3.select(this)
              .attr("stroke", "purple")
              .raise()
            hideTooltip()
          })

        
      // Calculate and add slope
      this.slope = null
      if (this.data && this.data.length) {

        let casesByDate = this.data
        casesByDate = casesByDate.filter(d => moment(this.start).isSameOrBefore(d.date))
        casesByDate = casesByDate.filter(d => moment(this.end).isSameOrAfter(d.date))
        casesByDate = _.orderBy(casesByDate, ['date'], ['asc'])
        let lastCases = casesByDate[casesByDate.length - 1].average
        let firstCases = casesByDate[0].average
        this.slope = (lastCases - firstCases) / moment(this.end).diff(this.start, 'days')
        this.slope = Math.round(this.slope*10)/10
      }

    },
    
  }
}
</script>

<style lang="scss">

#curve-chart {

  #chartWrapper {
    max-width: 850px;
    margin: 0 auto;
    width: 100%;
  }
  #curveChart {
    padding-bottom: 45%;
    width: 100%;
    background: #ffffffbb;
    border-radius: 3px;
  }
  #curveChart > svg {
    position: absolute;
  }

  #curveChart {
    overflow: hidden;
  }

  #curveChart .tick {
    visibility: hidden;
  }

  #curveChart .tick:nth-child(9n + 2) {
    // visibility: visible;
  }

  #curveChart {
    position: relative;
  }
}

</style>


